import i18next from 'i18next';

export const getFormattedTimeAgo = (unixTimestamp: number | undefined): string => {
  if (!unixTimestamp || isNaN(unixTimestamp)) {
    return '-';
  }

  const currentTime = Date.now() / 1000;
  const timeDifference = currentTime - unixTimestamp;
  const t = i18next.t;

  if (timeDifference < 120) {
    return t('time_1_minute_ago');
  }
  if (timeDifference < 3600) {
    return t('time_x_minutes_ago', { count: Math.floor(timeDifference / 60) });
  }
  if (timeDifference < 7200) {
    return t('time_1_hour_ago');
  }
  if (timeDifference < 86400) {
    return t('time_x_hours_ago', { count: Math.floor(timeDifference / 3600) });
  }
  if (timeDifference < 172800) {
    return t('time_1_day_ago');
  }
  if (timeDifference < 2592000) {
    return t('time_x_days_ago', { count: Math.floor(timeDifference / 86400) });
  }
  if (timeDifference < 5184000) {
    return t('time_1_month_ago');
  }
  if (timeDifference < 31104000) {
    return t('time_x_months_ago', { count: Math.floor(timeDifference / 2592000) });
  }
  if (timeDifference < 62208000) {
    return t('time_1_year_ago');
  }
  return t('time_x_years_ago', { count: Math.floor(timeDifference / 31104000) });
};

export const getFormattedTimeDuration = (unixTimestamp: number | undefined): string => {
  if (!unixTimestamp || isNaN(unixTimestamp)) {
    return '-';
  }
  const currentTime = Date.now() / 1000;
  const timeDifference = currentTime - unixTimestamp;
  const t = i18next.t;

  if (timeDifference < 120) {
    return t('time_1_minute');
  }
  if (timeDifference < 3600) {
    return t('time_x_minutes', { count: Math.floor(timeDifference / 60) });
  }
  if (timeDifference < 7200) {
    return t('time_1_hour');
  }
  if (timeDifference < 86400) {
    return t('time_x_hours', { count: Math.floor(timeDifference / 3600) });
  }
  if (timeDifference < 172800) {
    return t('time_1_day');
  }
  if (timeDifference < 2592000) {
    return t('time_x_days', { count: Math.floor(timeDifference / 86400) });
  }
  if (timeDifference < 5184000) {
    return t('time_1_month');
  }
  if (timeDifference < 31104000) {
    return t('time_x_months', { count: Math.floor(timeDifference / 2592000) });
  }
  if (timeDifference < 62208000) {
    return t('time_1_year');
  }
  return t('time_x_years', { count: Math.floor(timeDifference / 31104000) });
};

export const getFormattedDate = (unixTimestamp: number | undefined, locale: string): string => {
  if (!unixTimestamp || isNaN(unixTimestamp)) {
    return '-';
  }
  const date = new Date(unixTimestamp * 1000);
  return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short', year: 'numeric' }).format(date);
};

export const formatLocalizedUTCTimestamp = (unixTimestamp: number | undefined, locale: string): string => {
  if (!unixTimestamp || isNaN(unixTimestamp)) {
    return '-';
  }
  const date = new Date(unixTimestamp * 1000);
  return (
    new Intl.DateTimeFormat(locale, {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: 'UTC',
      hour12: false,
    })
      .format(date)
      .replace(/,/g, '') + ' UTC'
  );
};
